import React, { Component } from "react";
import {
	View,
	StyleSheet,
	TextInput,
	Alert,
	Platform,
	Image,
	ScrollView,
	TouchableOpacity,
} from "react-native";
import { translate } from "react-i18next";
import VisibilityPoller from "components/VisibilityPoller";
import BackgroundImage from "components/BackgroundImage";
import KeyboardView from "components/KeyboardView";
import ViewScroll from "components/ViewScroll";
import Text from "components/StyledText";

import { reset, push } from "utils/navigation";
import Header from "components/Header";

import * as x from "../../../styles/css";

class ConnectConfirm extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;
	static bypass = true;

	constructor(props) {
		super(props);
		this.state = {
			paused: false,
		};
		this.goHome = this.goHome.bind(this);
	}

	goHome() {
		this.setState(
			{
				paused: true,
			},
			() => {
				setTimeout(() => {
					reset({ web: "/", mobile: "Home" }, this.props);
				}, 5000);
			}
		);
	}

	render() {
		const nav = this.props.navigation;

		const { t } = this.props;

		return (
			<ViewScroll>
				<VisibilityPoller
					poll={this.goHome}
					duration={5}
					paused={this.state.paused}
				/>
				<TouchableOpacity
					activeOpacity={1}
					onPress={this.goHome}
					style={[x.d.flex, x.justifyContent.center]}
				>
					<Header style={{ textAlign: "center" }}>
						{t("deviceAuth.connectConfirm.title")}
					</Header>
					<Text style={{ textAlign: "center" }}>
						{t("deviceAuth.connectConfirm.help")}
					</Text>
				</TouchableOpacity>
			</ViewScroll>
		);
	}
}

export default translate()(ConnectConfirm);



// WEBPACK FOOTER //
// ./src/views/DeviceAuth/ConnectConfirm/index.js